
/**
* @memberof rmOBA
* @ngdoc service
* @name rmUserLocationData
* @param $q {service} promise service
* @param $http {service} angular http request promise service
* @description 
*   Get and put user data from and to local storage
*/

rmOBA.factory('rmUserLocationData',
    function ($q, $http) {
        var USER_LOCATION_DATA_ID = 'rm-oba-user-location-data';


        return {
                dummyStorage: {"postingLocationNumber":"9999999999","postingLocationAddress":"1 Town Road\nCityVille\nEngland\nSMD 5TFU","accountNumber":"0123456789","customerEmailAddress":"bob@example.com","customerPhoneNumber":"0123546789","oBAYourReference":"4565"},

                /**
                * @memberof rmUserLocationData
                * @function get
                * @desc Retreive saved user-completed location data from local storage
                * @returns {object} values for each completed field from the location form 
                */ 
                get: function () {
                    return JSON.parse(localStorage.getItem(USER_LOCATION_DATA_ID) || '[]');
                },

                /**
                * @memberof rmUserLocationData
                * @function put
                * @desc Save user-completed location data to local storage
                * @param {object} locationFormData Angular object of completed location form data
                */ 
                put: function (locationFormData) {
                    localStorage.setItem(USER_LOCATION_DATA_ID, JSON.stringify(locationFormData));
                }
            };
        });